
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/hotel/privacy",
      function () {
        return require("private-next-pages/[lang]/hotel/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/hotel/privacy"])
      });
    }
  